import {
  useCustomerViewedProduct,
  useRecentViewProducts,
} from "@api/products/recentviews";
import React, { useEffect, useState } from "react";
import RelatedItem from "../related-product/RelatedItem";
import {
  PRODUCT_DEFAULT_PAGE,
  PRODUCT_DEFAULT_SORT_BY,
  RELATED_PAGE_SIZE,
} from "@const/products.const";
import { ProductSortBy } from "@interfaces/components/product-filters.interface";
import SkeletonProductItem from "@components/atoms/skeleton/ui-product-item";
import { useRouter } from "next/router";

type Props = {
  neqPid: string | undefined;
  cusId: string | undefined;
};

const RecentView = ({ neqPid, cusId }: Props) => {
  // set paging states
  const [selectedPage, setSelectedPage] =
    useState<number>(PRODUCT_DEFAULT_PAGE);
  const [selectedSortBy, setSelectedSortBy] =
    useState<ProductSortBy>("find_in_set");

  const router = useRouter();
  // Products Viewed
  const {
    data: dataViewed,
    isLoading: isLoadingViewed,
    error: errorViewed,
    mutate,
  } = useCustomerViewedProduct({
    customerId: cusId,
  });
  // console.log("current", neqPid);
  // console.log("datasViewed", dataViewed);

  // Revalidate data when route changes
  useEffect(() => {
    const handleRouteChange = () => {
      mutate(); // Revalidate data
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events, mutate]);

  // Fetch Products Data from Products Viewed
  const {
    data: dataRecent,
    isLoading: isLoadingRecent,
    error: errorRecent,
  } = useRecentViewProducts({
    entityId: dataViewed,
    neqProductId: neqPid,
    productDisplayConfig: {
      pageSize: RELATED_PAGE_SIZE,
      currentPage: selectedPage,
      sortBy: selectedSortBy,
    },
  });
  // console.log("fromApi", dataRecent?.items);

  return (
    // <>
    //   {isLoadingRecent ? (
    //     <SkeletonProductItem />
    //   ) : (

    //   )}
    // </>
    <>
      {dataRecent && dataRecent?.items.length > 0 ? (
        <>
          {isLoadingRecent ? (
            <SkeletonProductItem />
          ) : (
            <>
              <h4 className="mt-3">สินค้าที่ดูล่าสุด</h4>
              <div className="product-list-grid product-col-lg-5">
                <div className="row">
                  <RelatedItem dataRelated={dataRecent?.items} />
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default RecentView;
